import React from "react";
import { PublicVisitBroadcastDetailsTypes } from "../../../../messages/Visit";
import { DayOfWeekPatternShift } from "../../../../messages/VisitBroadcast";
import { Visit } from "../../../../system/AppState/AppVisitsState";
import { formatDates, formatDayOfWeek, formatTimes } from "../../../../utils/dateUtils";
import { withDefault } from "../../../../utils/withDefault";
import { AppList, AppListItem } from "../../../Generic/AppList";

export type PatternVisit = Visit.Available & {
  publicVisitBroadcastDetails: PublicVisitBroadcastDetailsTypes.Pattern;
};

interface Props {
  visit: PatternVisit;
}

export const PendingConfirmationVisitDatesPattern = ({ visit }: Props) => {
  const { daysOfWeek } = visit.publicVisitBroadcastDetails.weeklyPattern;
  const { startTimeLocal, endTimeLocal } = visit.publicVisitBroadcastDetails;

  const pendingConfirmationInstances = withDefault(
    visit.caregiverVisitEngagementDetails.pendingConfirmationInstances,
    []
  );

  const isAssignedDay = (day: string) => {
    for (const { startTime } of pendingConfirmationInstances) {
      if (startTime.dayOfWeek().toString() === day) {
        return true;
      }
    }

    return false;
  };

  const isAssignedShift = (day: string, shift: DayOfWeekPatternShift) => {
    for (const { startTime, endTime } of pendingConfirmationInstances) {
      if (
        startTime.dayOfWeek().toString() === day &&
        startTime.toLocalTime().toString() === shift.startAt.toString() &&
        endTime.toLocalTime().toString() === shift.endAt.toString()
      ) {
        return true;
      }
    }

    return false;
  };

  const filterShifts = (day: string, shifts: DayOfWeekPatternShift[]) =>
    shifts.filter((shift) => isAssignedShift(day, shift));

  const filteredDaysOfWeek = Object.entries(daysOfWeek).filter(([day]) => isAssignedDay(day));

  return (
    <AppList>
      <AppListItem title={formatDates(startTimeLocal.toLocalDate(), endTimeLocal.toLocalDate())} />
      {filteredDaysOfWeek.map(([day, shifts]) => (
        <VisitDay key={day} day={day} shifts={filterShifts(day, shifts)} />
      ))}
    </AppList>
  );
};

const VisitDay = ({ day, shifts }: { day: string; shifts: DayOfWeekPatternShift[] }) => (
  <AppListItem key={day} title={formatDayOfWeek(day)} extra={<VisitDayShifts shifts={shifts} />} />
);

const VisitDayShifts = ({ shifts }: { shifts: DayOfWeekPatternShift[] }) => (
  <AppList density="densed">
    {shifts.map((shift, i) => (
      <AppListItem key={i} soft={true} title={""} trailing={formatTimes(shift)} />
    ))}
  </AppList>
);
